

const initialState = {
  preferred_venue_id: '',
  preferred_fixture_menu_tab: 0,
};

export default function userPref(state = initialState, action) {
  switch (action.type) {
    case 'SET_PREFERRED_VENUE_ID':
      return {
        preferred_venue_id: action.preferred_venue_id,
      };
    case 'SET_PREFERRED_FIXTURE_MENU_TAB':
      return {
        preferred_fixture_menu_tab: action.preferred_fixture_menu_tab,
      };
    default:
      return initialState;
  }
};


export function changePreferredVenueId(preferred_venue_id) {
  return {
    type: 'SET_PREFERRED_VENUE_ID',
    preferred_venue_id: preferred_venue_id,
  };
}

export function changePreferredMenuTab(tab_index) {
  return {
    type: 'SET_PREFERRED_FIXTURE_MENU_TAB',
    preferred_fixture_menu_tab: tab_index,
  };
}

export function setPreferredVenueId(preferred_venue_id) {
  return (
    dispatch
  ) => {
    return dispatch(changePreferredVenueId(preferred_venue_id));
  };
}

export function setPreferredFixtureMenuTab(tab_index) {
  return (
    dispatch
  ) => {
    return dispatch(changePreferredMenuTab(tab_index));
  };
}


// WEBPACK FOOTER //
// ./src/app/redux/modules/userPref.js